// Calls to admin_backend /admin/domain-extractor/*. Every response is
// { status, msg, data }; anything but status 200 is thrown as an Error(msg).
const BASE = `${process.env.REACT_APP_SERVER_URL}/admin/domain-extractor`;

export async function de(path, { method = "GET", body, form } = {}) {
  const opts = { method, credentials: "include" };
  if (form) opts.body = form;
  else if (body !== undefined) {
    opts.headers = { "Content-Type": "application/json" };
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${BASE}${path}`, opts);
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.status !== 200) {
    throw new Error(json.msg || `Request failed (${res.status})`);
  }
  return json.data;
}

export const downloadUrl = (id) => `${BASE}/jobs/${id}/download`;

export const ACTIVE = ["queued", "running"];

export const STATUS = {
  queued: { label: "Queued", tone: "info" },
  running: { label: "Running", tone: "info" },
  done: { label: "Done", tone: "ok" },
  failed: { label: "Failed", tone: "danger" },
  cancelled: { label: "Cancelled", tone: "warn" },
  interrupted: { label: "Interrupted", tone: "warn" },
};

// First CSV record of the file, honouring quotes, so the page can offer the
// real column names before anything is uploaded.
export async function readCsvHeaders(file) {
  const text = (await file.slice(0, 65536).text()).replace(/^﻿/, "");
  const cells = [];
  let cur = "";
  let quoted = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (quoted) {
      if (ch === '"' && text[i + 1] === '"') {
        cur += '"';
        i++;
      } else if (ch === '"') quoted = false;
      else cur += ch;
    } else if (ch === '"') quoted = true;
    else if (ch === ",") {
      cells.push(cur.trim());
      cur = "";
    } else if (ch === "\n" || ch === "\r") break;
    else cur += ch;
  }
  cells.push(cur.trim());
  return cells.filter((c, i) => c || i < cells.length - 1);
}

export function guessColumn(headers, re) {
  return headers.find((h) => re.test(h)) || "";
}

export function when(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(d);
  }
}

// Colour for a result value (a class name in DomainExtractor.module.css).
// Values come from the backend's fixed vocabulary, plus raw WHOIS org names.
export function toneOf(value) {
  const v = String(value || "").trim().toLowerCase();
  if (!v) return null;
  if (v === "google") return "pGoogle";
  if (v === "outlook") return "pOutlook";
  if (v === "aws") return "pAws";
  if (v === "gcp") return "pGcp";
  if (v === "azure") return "pAzure";
  if (v === "cloudflare") return "pCloudflare";
  if (v === "personal email") return "pPersonal";
  if (v === "no dns" || v === "error" || v === "unknown provider") return "pBad";
  return "pOther";
}

export const num =(n) => (n == null ? "—" : Number(n).toLocaleString("en-IN"));
